import React, {Component, useCallback, useEffect, useState} from 'react';
import {Dashboard, useUppy} from '@uppy/react'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import ImageSizePlugin from '../uppy/ImageSizePlugin'; 
import useFirebaseFunction from "../utils/useFirebaseFunction";
import {useParams} from "react-router-dom";
import { Modal } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import Compressor from "@uppy/compressor"
const Uppy = require('@uppy/core')
const AwsS3 = require('@uppy/aws-s3')
// const {Compressor} = require('@uppy/compressor');



export default function UploadGallery ({opened, setOpened, board}) {

    const [signUpload] = useFirebaseFunction("sign_upload2");


    const sign = useCallback((data) => {
         return signUpload(data)
             .then(({data}) => data);
    }, [signUpload]);

    const uppy = React.useMemo(() => {
        return new Uppy({

            meta: { type: 'avatar' },
            autoProceed: false,
            restrictions: {
                maxFileSize: 50000000,
                allowedFileTypes: ['image/jpg', 'image/jpeg', 'image/png']
            }
        })
            .use(Compressor, {
                quality: 0.8,
                limit: 10,
                maxWidth: 2000
            })
            .use(ImageSizePlugin, {})
            .use(AwsS3, {
                limit: 10,
                getUploadParameters (file) {
                    // Send a request to our PHP signing endpoint.
                    return sign({
                        fileName: file.name,
                        fileExtension: file.type,
                        board: board,
                        height: file.meta.height,
                        width: file.meta.width
                    }).then((data) => {
                        // Return an object in the correct shape.
                        console.log(data);
                        return {
                            method: data.method,
                            url: 'https://picboard-storage.s3-accelerate.amazonaws.com',
                            fields: data.fields
                        }
                    })
                }
            })
    }, [board])
    React.useEffect(() => {
        return () => uppy.close({ reason: 'unmount' })
    }, [uppy])

    const { width } = useViewportSize();
    const [desktop,setDesktop] = useState(true);
    useEffect(()=>{
        if(width > 535){
            setDesktop(true);
        } else {
            setDesktop(false);
        }
    },[width]);

    return  (
        <Modal
            centered={true}
            size={desktop ? 'xl' : '90%'}
            withinPortal={true}
            opened={opened}
            setOpened={setOpened}
            withCloseButton={false}
            onClose={() => setOpened(false)}
        >
            <Dashboard 
                doneButtonHandler={() => setOpened(false)}
                locale={{
                    strings:{
                        dropPasteFiles:"Trage fișierele aici sau %{browseFiles}",
                        browseFiles:"selectează fișierele"
                    },
                }} 
                uppy={uppy}  
            />
        </Modal>
    )
}
